import CollectionEditor from "#root/components/collection-editor";
import * as Fields from "#root/components/form/fields";
import StandardEditor from "#root/components/standard-editor";
import { accountCollection } from "#root/schema/account";
import { billingInvoiceCollection, getBillingInvoiceItemCollection } from "#root/schema/invoices";
import { productCollection } from "#root/schema/product";
import type { ReactNode } from "react";
import { Fragment, useMemo } from "react";
import PageLayout from "./layout";

export default function ({ invoiceId }): ReactNode {
  const invoiceItemsCollection = useMemo(() => getBillingInvoiceItemCollection(invoiceId), [invoiceId]);

  return (
    <PageLayout title="Billing - Edit Invoice">
      <section>
        <h2>Edit Invoice</h2>
        <StandardEditor id={invoiceId} collection={billingInvoiceCollection}>
          <Fields.Set name="id">
            <Fields.Hidden/>
          </Fields.Set>
          <Fields.Set name="accountId">
            <label>Account</label>
            <Fields.AutoComplete required collection={accountCollection}/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="date">
            <label>Invoice Date</label>
            <Fields.DateField/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="paid">
            <label>Amount Paid</label>
            <Fields.Currency/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="segment">
            <label>Segment</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="purchaseOrder">
            <label>Purchase Order #</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="note">
            <label>Note</label>
            <Fields.TextArea rows={3}/>
            <Fields.Validity/>
          </Fields.Set>
        </StandardEditor>
        <h2>Invoice Items</h2>
        <ItemEditor collection={invoiceItemsCollection}/>
      </section>
    </PageLayout>
  );
}

function ItemEditor({ collection }) {
  return (
    <CollectionEditor
      collection={collection}
      header={
        <div className="row header">
          <div className="cell">Product Description</div>
          <div className="cell">Rate</div>
          <div className="cell">Quantity</div>
          <div className="cell">Interval</div>
          <div className="cell">Linked Product</div>
          <div className="cell">Action</div>
        </div>
      }
    >
      {({ message, id }) => (
        <Fragment>
          <div className="row">
            <div className="cell">
              <Fields.Set name="id" className="hidden">
                <Fields.Hidden/>
              </Fields.Set>
              <Fields.Set name="description" style={{ minWidth: "20em" }}>
                <Fields.String/>
              </Fields.Set>
            </div>
            <div className="cell">
              <Fields.Set name="rate" style={{ maxWidth: "6em" }}>
                <Fields.Currency/>
              </Fields.Set>
            </div>
            <div className="cell">
              <Fields.Set name="quantity" style={{ maxWidth: "4em" }}>
                <Fields.Integer/>
              </Fields.Set>
            </div>
            <div className="cell">
              <Fields.Set name="interval" style={{ minWidth: "7em" }}>
                <Fields.Select required>
                  <Fields.Option value="One-Time">One-Time</Fields.Option>
                  <Fields.Option value="Monthly">Monthly</Fields.Option>
                  <Fields.Option value="Quarterly">Quarterly</Fields.Option>
                  <Fields.Option value="Annual">Annual</Fields.Option>
                </Fields.Select>
              </Fields.Set>
            </div>
            <div className="cell">
              <Fields.Set name="productId" style={{ maxWidth: "12em" }}>
                <Fields.AutoComplete collection={productCollection}/>
              </Fields.Set>
            </div>
            <div className="cell">
              &nbsp;
              <Fields.Submit>{id ? "Save" : "Add Item"}</Fields.Submit>
              {id ? <Fields.Delete>Delete</Fields.Delete> : null}
            </div>
          </div>
        </Fragment>
      )}
    </CollectionEditor>
  );
}
